import { createSlice } from "@reduxjs/toolkit";

const keyWorsStatsSlice = createSlice({
  name: "keyWorsStatsSlice",
  initialState: {
    screenshotData: null,
  },
  reducers: {
    setScreenshotData: (state, action) => {
      state.screenshotData = action?.payload;
    },
    clearScreenshots: (state, action) => {
      state.screenshotData = null
    }
  },
});

// this is for dispatch
export const { screenshotData, clearScreenshots } = keyWorsStatsSlice.actions;

// this is for configureStore
export default keyWorsStatsSlice.reducer;
